// MultiLife — scripts propios (prefijo mt-)
//
// REGLA: el contenido de la web NUNCA depende de este archivo para verse.
// El CSS solo oculta elementos para animarlos si aquí confirmamos que el JS
// está vivo (clase .mt-anim en <html>). Si este archivo no carga, falla o el
// navegador es antiguo, la página se ve entera igualmente.

(function () {
  'use strict';

  // Varias secciones cargan este archivo; ejecútalo una sola vez.
  if (window.__mtScriptsLoaded) return;
  window.__mtScriptsLoaded = true;

  var supportsObserver = typeof window.IntersectionObserver === 'function';
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (supportsObserver && !reduceMotion) {
    document.documentElement.classList.add('mt-anim');
  }

  var observer = null;

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -30px 0px' }
    );
    return observer;
  }

  function initReveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;

    // Sin animaciones: se muestra todo directamente.
    if (!document.documentElement.classList.contains('mt-anim')) {
      Array.prototype.forEach.call(els, function (el) {
        el.classList.add('mt-visible');
      });
      return;
    }

    var obs = getObserver();
    Array.prototype.forEach.call(els, function (el, i) {
      el.style.setProperty('--mt-i', i % 8);
      obs.observe(el);
    });
  }

  // Red de seguridad: si por lo que sea el observador no reacciona, a los 2,5 s
  // se muestra todo lo que ya esté en pantalla. Así nada queda invisible.
  function safetyNet() {
    var pending = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    Array.prototype.forEach.call(pending, function (el) {
      var box = el.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) {
        el.classList.add('mt-visible');
      }
    });
  }

  /* ======================================================================
     Aviso de descuento (recuperación de carrito)
     ====================================================================== */

  var cartCount = null; // nº de artículos conocido; null = todavía no lo sabemos

  function almacen(accion, clave, valor) {
    // localStorage puede lanzar error en modo privado de Safari: nunca debe romper la página.
    try {
      if (accion === 'get') return window.localStorage.getItem(clave);
      if (accion === 'set') window.localStorage.setItem(clave, valor);
    } catch (e) {}
    return null;
  }

  function initPopup() {
    var pop = document.querySelector('[data-mt-popup]');
    if (!pop || pop.dataset.mtReady === '1') return;
    pop.dataset.mtReady = '1';

    var card = pop.querySelector('.mt-pop-card');
    var codigo = pop.getAttribute('data-code') || '';
    var dias = parseInt(pop.getAttribute('data-days'), 10);
    var segundosInactivo = parseInt(pop.getAttribute('data-idle'), 10) || 60;
    var permiteSalida = pop.getAttribute('data-on-exit') === 'true';
    var permiteQuitar = pop.getAttribute('data-on-remove') === 'true';
    var permiteInactivo = pop.getAttribute('data-on-idle') === 'true';
    var conCarritoVacio = pop.getAttribute('data-empty-cart') === 'true';
    var etiquetaCopiado = pop.getAttribute('data-copied-label') || '¡Copiado!';

    var CLAVE = 'mt-popup-visto';
    var mostradoEnEstaPagina = false;
    var focoPrevio = null;
    var temporizadorInactivo = null;

    function vistoRecientemente() {
      if (!dias || dias <= 0) return false;
      var ts = parseInt(almacen('get', CLAVE), 10);
      if (!ts) return false;
      return Date.now() - ts < dias * 86400000;
    }

    function marcarVisto() {
      almacen('set', CLAVE, String(Date.now()));
    }

    function elementosEnfocables() {
      return card.querySelectorAll('a[href], button:not([disabled])');
    }

    function alPulsarTecla(e) {
      if (e.key === 'Escape') {
        cerrar();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = elementosEnfocables();
      if (!f.length) return;
      var primero = f[0];
      var ultimo = f[f.length - 1];
      if (e.shiftKey && document.activeElement === primero) {
        e.preventDefault();
        ultimo.focus();
      } else if (!e.shiftKey && document.activeElement === ultimo) {
        e.preventDefault();
        primero.focus();
      }
    }

    function abrir() {
      if (!pop.hidden) return;
      focoPrevio = document.activeElement;
      pop.hidden = false;
      document.body.classList.add('mt-pop-open');
      document.addEventListener('keydown', alPulsarTecla);
      var f = elementosEnfocables();
      if (f.length) f[0].focus();
    }

    function cerrar() {
      if (pop.hidden) return;
      pop.hidden = true;
      document.body.classList.remove('mt-pop-open');
      document.removeEventListener('keydown', alPulsarTecla);
      marcarVisto();
      if (focoPrevio && focoPrevio.focus) focoPrevio.focus();
    }

    function intentarMostrar(motivo) {
      if (mostradoEnEstaPagina || !pop.hidden) return;
      if (motivo === 'salida' && !permiteSalida) return;
      if (motivo === 'quitar' && !permiteQuitar) return;
      if (motivo === 'inactivo' && !permiteInactivo) return;
      if (vistoRecientemente()) return;
      // Al quitar del carrito sí queremos mostrarlo aunque quede vacío: es justo el caso.
      if (motivo !== 'quitar' && !conCarritoVacio && !cartCount) return;
      mostradoEnEstaPagina = true;
      abrir();
    }

    // --- Cerrar ---
    pop.querySelectorAll('[data-mt-popup-close]').forEach(function (b) {
      b.addEventListener('click', cerrar);
    });

    // --- Copiar el código ---
    var botonCopiar = pop.querySelector('[data-mt-popup-copy]');
    var textoCodigo = pop.querySelector('[data-mt-popup-code-text]');
    if (botonCopiar && textoCodigo) {
      botonCopiar.addEventListener('click', function () {
        var original = textoCodigo.textContent;
        function confirmar() {
          textoCodigo.textContent = etiquetaCopiado;
          botonCopiar.classList.add('is-copied');
          setTimeout(function () {
            textoCodigo.textContent = original;
            botonCopiar.classList.remove('is-copied');
          }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(confirmar).catch(copiaManual);
        } else {
          copiaManual();
        }
        function copiaManual() {
          // Respaldo para navegadores sin API de portapapeles (o sin HTTPS)
          try {
            var tmp = document.createElement('textarea');
            tmp.value = codigo;
            tmp.setAttribute('readonly', '');
            tmp.style.position = 'absolute';
            tmp.style.left = '-9999px';
            document.body.appendChild(tmp);
            tmp.select();
            document.execCommand('copy');
            document.body.removeChild(tmp);
            confirmar();
          } catch (e) {}
        }
      });
    }

    // --- Al pulsar "aplicar" nos vamos a /discount/CODIGO: no repetir el aviso ---
    var botonAplicar = pop.querySelector('[data-mt-popup-apply]');
    if (botonAplicar) botonAplicar.addEventListener('click', marcarVisto);

    // --- Disparador: intento de salida (solo con ratón de verdad) ---
    var punteroFino = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    if (punteroFino) {
      document.addEventListener('mouseout', function (e) {
        if (e.clientY <= 0 && !e.relatedTarget) intentarMostrar('salida');
      });
    }

    // --- Disparador: inactividad (funciona también en móvil) ---
    function reiniciarInactividad() {
      if (!permiteInactivo) return;
      clearTimeout(temporizadorInactivo);
      temporizadorInactivo = setTimeout(function () {
        intentarMostrar('inactivo');
      }, segundosInactivo * 1000);
    }
    ['mousemove', 'keydown', 'scroll', 'touchstart', 'click'].forEach(function (ev) {
      document.addEventListener(ev, reiniciarInactividad, { passive: true });
    });
    reiniciarInactividad();

    // --- Disparador: quitar algo del carrito ---
    // Dawn actualiza el carrito con fetch; envolvemos fetch para enterarnos.
    // Siempre devolvemos la promesa original: si algo falla aquí, el carrito sigue funcionando.
    var fetchNativo = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;

    function refrescarCarrito() {
      if (!fetchNativo) return;
      try {
        fetchNativo('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (c && typeof c.item_count === 'number') cartCount = c.item_count;
          })
          .catch(function () {});
      } catch (e) {}
    }

    if (permiteQuitar && fetchNativo && !window.__mtCartWatch) {
      window.__mtCartWatch = true;
      window.fetch = function () {
        var respuesta = fetchNativo.apply(null, arguments);
        var url = '';
        try {
          url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
        } catch (e) {}
        if (url && /\/cart\/(change|update|clear|add)/.test(url)) {
          try {
            respuesta
              .then(function (res) {
                res
                  .clone()
                  .json()
                  .then(function (datos) {
                    // OJO: /cart/add.js devuelve la línea añadida, NO el carrito entero,
                    // así que no trae item_count. Si no viene, hay que releer el carrito
                    // o el contador se queda obsoleto y el aviso nunca salta.
                    if (!datos || typeof datos.item_count !== 'number') {
                      refrescarCarrito();
                      return;
                    }
                    var anterior = cartCount;
                    cartCount = datos.item_count;
                    if (anterior !== null && datos.item_count < anterior) {
                      intentarMostrar('quitar');
                    }
                  })
                  .catch(function () { refrescarCarrito(); });
              })
              .catch(function () {});
          } catch (e) {}
        }
        return respuesta;
      };
    }

    // --- Estado inicial del carrito ---
    refrescarCarrito();

    // --- En el editor de temas: mostrarlo al seleccionar la sección, para poder verlo ---
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.querySelector && e.target.querySelector('[data-mt-popup]')) abrir();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.querySelector && e.target.querySelector('[data-mt-popup]')) cerrar();
      });
    }
  }

  function boot() {
    initReveal(document);
    initPopup();
    setTimeout(safetyNet, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // El editor de temas recarga secciones sueltas: hay que reinicializarlas
  // o se quedarían invisibles al editarlas.
  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
    initPopup();
  });
})();
